import { useLocation, useNavigate } from 'react-router-dom';

import { useBrandStore } from 'stores';
import LockedBrandBannerView from './LockedBrandBanner.View';
import { BrandStatus } from 'types/stores/brand-store';

const LockedBrandBanner = () => {
  const location = useLocation();
  const { brand } = useBrandStore();
  const navigate = useNavigate();

  const ROUTES_TO_INCLUDE = [
    `/brand/${brand?.brandId}/audiences`,
    `/brand/${brand?.brandId}/integrations`,
  ];

  const onButtonClick = () => {
    navigate(`/brand/${brand.brandId}/settings/billing`);
  };

  const shouldSkipBanner = ROUTES_TO_INCLUDE.some((path) => location.pathname === path);

  // don't show on specific routes regardless of the brand status
  if (!shouldSkipBanner) return null;

  // if the brand is locked, then we need to show the banner.
  // it shouldn't show for any status that is not locked
  if (brand.status !== BrandStatus.Locked) return null;

  // when brand is managed, we don't show the banner
  if (brand.isManaged) return null;

  return <LockedBrandBannerView onButtonClick={onButtonClick} />;
};

export default LockedBrandBanner;
